export default __webpack_public_path__ + "static/media/munny.43d4bd5c.png";